import { render } from "./LinkDownload.vue?vue&type=template&id=5eac6ac5&scoped=true"
import script from "./LinkDownload.vue?vue&type=script&lang=js"
export * from "./LinkDownload.vue?vue&type=script&lang=js"

import "./LinkDownload.vue?vue&type=style&index=0&id=5eac6ac5&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eac6ac5"]])

export default __exports__